<template>
  <v-row class="mb-2">
    <v-col cols="6">
      <slot
        name="field"
        :disabled="useEventSetting"
        :value="localValue"
        :update-value="updateValue"
      >
        <!-- Default field implementation -->
        <v-text-field
          :value="localValue"
          :label="label"
          :type="type"
          :rules="rules"
          :disabled="useEventSetting"
          :min="min"
          :required="required"
          @input="updateValue"
        />
      </slot>
    </v-col>
    <v-col cols="5" offset-md="1">
      <v-checkbox
        :input-value="useEventSetting"
        :label="eventSettingLabel"
        class="mr-5"
        :style="checkboxStyle"
        @change="handleInheritanceChange"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InheritableField",
  props: {
    value: {
      required: true,
    },
    eventValue: {
      required: true,
    },
    inherit: {
      type: Boolean,
      default: true,
    },
    eventSettingLabel: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    min: {
      type: [String, Number],
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
    checkboxStyle: {
      type: String,
      default: "padding-top: 12px",
    },
  },
  computed: {
    useEventSetting: {
      get() {
        return this.inherit;
      },
      set(value) {
        this.handleInheritanceChange(value);
      },
    },
    localValue() {
      return this.useEventSetting ? this.eventValue : this.value;
    },
  },
  methods: {
    updateValue(newValue) {
      if (!this.useEventSetting) {
        this.$emit("input", newValue);
      }
    },
    handleInheritanceChange(useEventSetting) {
      this.$emit("inherit-change", useEventSetting);
      if (useEventSetting) {
        this.$emit("input", this.eventValue);
      }
    },
  },
};
</script>
